<template>
  <div>

    <div class="box">
      <div class="flex flex-wrap items-center">

        <div class="flex-grow mb-1">

          <div class="flex w-full md:w-2/3 sm:w-10/12">
            <input
              type="text"
              v-model="searchInput"
              placeholder="Filter"
              class="form-control h-10 flex-grow px-5 text-sm"
            >
          </div>

          <p class="text-xs mt-0 ml-1" v-if="query.search !== ''">
            Searching for <span class="text-red-500 font-bold">{{ query.search }}</span>
          </p>
        </div>
        <div class="flex">
          <button
            type="button"
            class="btn btn-green text-sm px-3 flex items-center mb-1"
            :disabled="!exportFile.ageing.enabled"
            @click="exportAgeing"
          >
            <i class="fas fa-spinner fa-spin mr-2" v-if="!exportFile.ageing.enabled"></i>
            <span>Export</span>
          </button>

          <button class="btn w-10 h-10 flex items-center justify-center focus:outline-none hover:text-green-500 mb-1" @click="get">
            <i class="fas fa-sync-alt"></i>
          </button>
        </div>

      </div>

      <div class="flex flex-wrap">

        <div class="w-full overflow-x-auto">
          <p class="text-lg text-center my-12" v-if="!hasAgeing">No data to display</p>
          <div v-else>
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Contact</th>
                  <th>Contact type</th>
                  <th>Total</th>
                  <th class="bg-blue-800 light:bg-blue-600">0-30</th>
                  <th class="bg-blue-700 light:bg-blue-500">31-60</th>
                  <th class="bg-blue-600 light:bg-blue-400">61-90</th>
                  <th class="bg-blue-500 light:bg-blue-300">91+</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="aoa in (filteredAgeing.length ? filteredAgeing : ageing)" :key="'ageing-for-' + aoa.contact_id">
                  <td>
                    <a class="text-link" @click.stop="$router.push($contactPageByType(aoa.contact, 'details'))">
                      #{{ aoa.contact.id }}
                      {{ aoa.contact.first_name }}
                      {{ aoa.contact.last_name }}
                      <span v-if="aoa.contact.company_name">
                        ({{ aoa.contact.company_name }})
                      </span>
                    </a>
                  </td>
                  <td>
                    <span :class="aoa.contact.type === 'supplier' ? 'text-red' : 'text-green'">
                      {{ aoa.contact.type }}
                    </span>
                  </td>
                  <td>{{ $formatMoney(aoa.total) }}</td>
                  <td class="bg-blue-800 light:bg-blue-600">{{ $formatMoney(aoa['0-30']) }}</td>
                  <td class="bg-blue-700 light:bg-blue-500">{{ $formatMoney(aoa['31-60']) }}</td>
                  <td class="bg-blue-600 light:bg-blue-400">{{ $formatMoney(aoa['61-90']) }}</td>
                  <td class="bg-blue-500 light:bg-blue-300">{{ $formatMoney(aoa['91+']) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import Fuse from 'fuse.js'

export default {
  data() {
    return {
      filteredAgeing: [],
      ageing: [],
      searchInput: '',
      query: {
        search: '',
      },
      exportFile: {
        ageing: {
          enabled: true,
        }
      },
    }
  },
  watch: {
    searchInput() {
      let fuse = new Fuse(this.ageing, {
        threshold: 0.2,
        keys: [
          'contact_id',
          'contact.first_name',
          'contact.last_name',
          'contact.company_name',
          'contact.type',
          'contact.email',
        ],
      })
      this.filteredAgeing = fuse.search(this.searchInput)
    }
  },
  computed: {
    hasAgeing() {
      return !!(this.filteredAgeing.length || this.ageing.length)
    },
    ...mapGetters({
      config: 'config/config',
      hasPermission: 'user/hasPermission',
    })
  },
  mounted() {
    this.get()
  },
  methods: {
    exportAgeing() {
      this.exportFile.ageing.enabled = false
      axios.get('reports/ageing-of-accounts/export', {
        params: {
          search: this.searchInput,
        },
        responseType: 'arraybuffer'
      })
        .then((response) => {
          this.$downloadFile(response)
          this.exportFile.ageing.enabled = true
        })
    },
    get() {
      axios.get('reports/ageing-of-accounts')
        .then(response => {
          let data = response.data
          for (let i in data.ageing) {
            data.ageing[i].contact = data.contacts.find(c => c.id === data.ageing[i].contact_id)
            data.ageing[i].total = parseFloat(data.ageing[i]['0-30'] || '0') + parseFloat(data.ageing[i]['31-60'] || '0') + parseFloat(data.ageing[i]['61-90'] || '0') + parseFloat(data.ageing[i]['91+'] || '0')
          }
          this.ageing = data.ageing
        })
    },
  }
}
</script>
